import { useCallback } from "react";
import AddFileForm from "../../../components/form/AddFileForm/AddFileForm";
import { MAX_ALLOWED_ENCLOSURE_SIZE_IN_BYTES, MAX_FILENAME_LENGTH_CHARS } from "../../../helpers/constants";
import BoxWithLabel from "../../../components/box/BoxWithLabel";
import i18n from "../../../i18n";


export const AddLocalFilesForm = (props) => {
    const {selectedFiles, setSelectedFiles} = props

    const onChooseFile = (e) => {
        const selectedFilesList = e.target.files;
        const enclosures = [];
        const notAddedFilesNames = [];

        if (selectedFilesList) {
            for (const file of Array.from(selectedFilesList)) {
                if (
                    file.size < MAX_ALLOWED_ENCLOSURE_SIZE_IN_BYTES &&
                    file.name.length < MAX_FILENAME_LENGTH_CHARS
                ) {
                    const enclosure = {
                        file: file,
                        docs_name: file.name,
                        content_type: file.type,
                        blob_url: window.URL.createObjectURL(new Blob([file], { type: file.type })),
                    };
                    enclosures.push(enclosure);
                } else {
                    notAddedFilesNames.push(file.name);
                }
            }

            setSelectedFiles((prevFiles) => [...prevFiles, ...enclosures]);

            if (notAddedFilesNames.length > 0) {
                toast.error(setNotAddedNames(notAddedFilesNames));
            }
        }
    };

    const onPreviewDocs = useCallback(
        async (itemId, index) => {
            if (index !== undefined) {
                const file = selectedFiles[index];
                window.open(file.blob_url, "_blank");
            }
        },
        [selectedFiles],
    );

    const onDeleteSelectedDocs = (index) => {
        setSelectedFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
    };

    return (
        <BoxWithLabel label={i18n.t("offers.SendOfferTab.additionalEnclosures")}>
            <AddFileForm
                showButtonWithFileRestriction={true}
                docs={selectedFiles}
                onChooseFile={onChooseFile}
                onDeleteFile={onDeleteSelectedDocs}
                onPreview={onPreviewDocs}
                fileType="docs"
                multiple={true}
            />
        </BoxWithLabel>
    )
};
